export default __webpack_public_path__ + "static/media/calconvert_background_xl1.5e41f18c.jpg";